export default __webpack_public_path__ + "static/intransitive-4f9b9624c51566220f7db9c2113038d8.svg";